import { render, staticRenderFns } from "./BirthdayModal.vue?vue&type=template&id=36a1ddcf"
import script from "./BirthdayModal.vue?vue&type=script&lang=js"
export * from "./BirthdayModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports